var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeEliminated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.709,
    height: 56.766,
    viewBox: "0 0 58.709 56.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1738",
    "data-name": "Rectangle 1738",
    width: 45.413,
    height: 37.5,
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16139",
    "data-name": "Group 16139",
    transform: "matrix(0.819, -0.574, 0.574, 0.819, 0, 26.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10356",
    "data-name": "Path 10356",
    d: "M.37,14.9v8.183H3.736v-1.13H1.652V19.474h2V18.345h-2V16.027H3.736V14.9Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10357",
    "data-name": "Path 10357",
    d: "M4.895,23.081V14.9H6.177v7.054H8.261v1.129Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1734",
    "data-name": "Rectangle 1734",
    width: 1.282,
    height: 8.183,
    transform: "translate(9.223 14.898)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10358",
    "data-name": "Path 10358",
    d: "M16.535,23.081v-5.7l-1.455,5.7h-.456l-1.43-5.7v5.7H11.911V14.9h1.665l1.282,5.055L16.165,14.9H17.8v8.183Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1735",
    "data-name": "Rectangle 1735",
    width: 1.282,
    height: 8.183,
    transform: "translate(19.198 14.898)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10359",
    "data-name": "Path 10359",
    d: "M24.981,23.081l-1.812-5.227v5.227H21.886V14.9h1.283l1.738,5.091V14.9h1.3v8.183Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10360",
    "data-name": "Path 10360",
    d: "M30.443,23.081l-.284-1.669H28.532l-.284,1.669H26.929L28.606,14.9h1.48l1.677,8.183Zm-1.1-6.723-.666,3.926h1.332Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10361",
    "data-name": "Path 10361",
    d: "M32.935,23.081V16.027h-1.27V14.9H35.5v1.129H34.217v7.054Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10362",
    "data-name": "Path 10362",
    d: "M36.424,23.081V14.9H39.79v1.129H37.706v2.319h2v1.129h-2v2.477H39.79v1.129Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16138",
    "data-name": "Group 16138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16137",
    "data-name": "Group 16137",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10363",
    "data-name": "Path 10363",
    d: "M40.949,23.081V14.9h1.837c1.862,0,2.626,1.754,2.626,4.1,0,2.367-.752,4.085-2.613,4.085ZM44.093,19c0-1.853-.407-2.969-1.307-2.969h-.555v5.925h.555c.912,0,1.307-1.141,1.307-2.956",
    fill: "red"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1736",
    "data-name": "Rectangle 1736",
    width: 44,
    height: 1.5,
    transform: "translate(0 12.489)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1737",
    "data-name": "Rectangle 1737",
    width: 44,
    height: 1.5,
    transform: "translate(0 23.989)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10364",
    "data-name": "Path 10364",
    d: "M22,29.863a11.145,11.145,0,0,1-9.069-4.687l1.223-.87a9.615,9.615,0,0,0,15.692,0l1.223.87A11.145,11.145,0,0,1,22,29.863",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10365",
    "data-name": "Path 10365",
    d: "M13.857,13.637l-1.27-.8a11.118,11.118,0,0,1,18.825,0l-1.269.8a9.618,9.618,0,0,0-16.286,0",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10366",
    "data-name": "Path 10366",
    d: "M22,37.5A18.782,18.782,0,0,1,4.313,24.99l1.415-.5a17.257,17.257,0,0,0,32.544,0l1.415.5A18.782,18.782,0,0,1,22,37.5",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10367",
    "data-name": "Path 10367",
    d: "M5.606,13.368,4.181,12.9a18.757,18.757,0,0,1,35.638,0l-1.424.467a17.258,17.258,0,0,0-32.789,0",
    fill: "red"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeEliminated);
export default __webpack_public_path__ + "static/media/badge-eliminated.2224a359818841aec4255d10c0919e27.svg";
export { ForwardRef as ReactComponent };